/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreatePlayer = /* GraphQL */ `
  subscription OnCreatePlayer {
    onCreatePlayer {
      id
      purpose
      name
      starTotal
      effortTotal
      rideDurTotal
      wattHrsTotal
      coinTotal
      createdAt
      updatedAt
      restricted {
        id
        stravaAccessToken
        stravaRefreshToken
        stravaTokenExpiresAt
        stravaScope
        createdAt
        updatedAt
      }
    }
  }
`;
export const onUpdatePlayer = /* GraphQL */ `
  subscription OnUpdatePlayer {
    onUpdatePlayer {
      id
      purpose
      name
      starTotal
      effortTotal
      rideDurTotal
      wattHrsTotal
      coinTotal
      createdAt
      updatedAt
      restricted {
        id
        stravaAccessToken
        stravaRefreshToken
        stravaTokenExpiresAt
        stravaScope
        createdAt
        updatedAt
      }
    }
  }
`;
export const onDeletePlayer = /* GraphQL */ `
  subscription OnDeletePlayer {
    onDeletePlayer {
      id
      purpose
      name
      starTotal
      effortTotal
      rideDurTotal
      wattHrsTotal
      coinTotal
      createdAt
      updatedAt
      restricted {
        id
        stravaAccessToken
        stravaRefreshToken
        stravaTokenExpiresAt
        stravaScope
        createdAt
        updatedAt
      }
    }
  }
`;
export const onCreatePlayerRestricted = /* GraphQL */ `
  subscription OnCreatePlayerRestricted($id: String) {
    onCreatePlayerRestricted(id: $id) {
      id
      stravaAccessToken
      stravaRefreshToken
      stravaTokenExpiresAt
      stravaScope
      createdAt
      updatedAt
    }
  }
`;
export const onUpdatePlayerRestricted = /* GraphQL */ `
  subscription OnUpdatePlayerRestricted($id: String) {
    onUpdatePlayerRestricted(id: $id) {
      id
      stravaAccessToken
      stravaRefreshToken
      stravaTokenExpiresAt
      stravaScope
      createdAt
      updatedAt
    }
  }
`;
export const onDeletePlayerRestricted = /* GraphQL */ `
  subscription OnDeletePlayerRestricted($id: String) {
    onDeletePlayerRestricted(id: $id) {
      id
      stravaAccessToken
      stravaRefreshToken
      stravaTokenExpiresAt
      stravaScope
      createdAt
      updatedAt
    }
  }
`;
export const onCreateActivityPeriod = /* GraphQL */ `
  subscription OnCreateActivityPeriod {
    onCreateActivityPeriod {
      id
      createdAt
      owner
      startDate
      effortCount
      starCount
      wattHrs
      coinCount
      rideDuration
      effortTotal
      starTotal
      wattHrsTotal
      coinTotal
      rideDurTotal
      updatedAt
      rides {
        items {
          id
          createdAt
          title
          duration
          kilometers
          wattHours
          coinGain
          starGain
          completed
          owner
          worldId
          updatedAt
        }
        nextToken
      }
      questEfforts {
        items {
          id
          createdAt
          score
          metric
          starRating
          starGain
          completed
          isRankChecked
          owner
          questId
          rideId
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onUpdateActivityPeriod = /* GraphQL */ `
  subscription OnUpdateActivityPeriod {
    onUpdateActivityPeriod {
      id
      createdAt
      owner
      startDate
      effortCount
      starCount
      wattHrs
      coinCount
      rideDuration
      effortTotal
      starTotal
      wattHrsTotal
      coinTotal
      rideDurTotal
      updatedAt
      rides {
        items {
          id
          createdAt
          title
          duration
          kilometers
          wattHours
          coinGain
          starGain
          completed
          owner
          worldId
          updatedAt
        }
        nextToken
      }
      questEfforts {
        items {
          id
          createdAt
          score
          metric
          starRating
          starGain
          completed
          isRankChecked
          owner
          questId
          rideId
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onDeleteActivityPeriod = /* GraphQL */ `
  subscription OnDeleteActivityPeriod {
    onDeleteActivityPeriod {
      id
      createdAt
      owner
      startDate
      effortCount
      starCount
      wattHrs
      coinCount
      rideDuration
      effortTotal
      starTotal
      wattHrsTotal
      coinTotal
      rideDurTotal
      updatedAt
      rides {
        items {
          id
          createdAt
          title
          duration
          kilometers
          wattHours
          coinGain
          starGain
          completed
          owner
          worldId
          updatedAt
        }
        nextToken
      }
      questEfforts {
        items {
          id
          createdAt
          score
          metric
          starRating
          starGain
          completed
          isRankChecked
          owner
          questId
          rideId
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onCreateRide = /* GraphQL */ `
  subscription OnCreateRide {
    onCreateRide {
      id
      createdAt
      title
      duration
      kilometers
      wattHours
      coinGain
      starGain
      completed
      owner
      worldId
      updatedAt
      player {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      activityPeriod {
        id
        createdAt
        owner
        startDate
        effortCount
        starCount
        wattHrs
        coinCount
        rideDuration
        effortTotal
        starTotal
        wattHrsTotal
        coinTotal
        rideDurTotal
        updatedAt
        rides {
          nextToken
        }
        questEfforts {
          nextToken
        }
      }
      questEfforts {
        items {
          id
          createdAt
          score
          metric
          starRating
          starGain
          completed
          isRankChecked
          owner
          questId
          rideId
          updatedAt
        }
        nextToken
      }
      questRanks {
        items {
          createdAt
          score
          starRating
          owner
          questId
          rideId
          effortId
          updatedAt
        }
        nextToken
      }
      world {
        id
        title
        createdAt
        updatedAt
        quests {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateRide = /* GraphQL */ `
  subscription OnUpdateRide {
    onUpdateRide {
      id
      createdAt
      title
      duration
      kilometers
      wattHours
      coinGain
      starGain
      completed
      owner
      worldId
      updatedAt
      player {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      activityPeriod {
        id
        createdAt
        owner
        startDate
        effortCount
        starCount
        wattHrs
        coinCount
        rideDuration
        effortTotal
        starTotal
        wattHrsTotal
        coinTotal
        rideDurTotal
        updatedAt
        rides {
          nextToken
        }
        questEfforts {
          nextToken
        }
      }
      questEfforts {
        items {
          id
          createdAt
          score
          metric
          starRating
          starGain
          completed
          isRankChecked
          owner
          questId
          rideId
          updatedAt
        }
        nextToken
      }
      questRanks {
        items {
          createdAt
          score
          starRating
          owner
          questId
          rideId
          effortId
          updatedAt
        }
        nextToken
      }
      world {
        id
        title
        createdAt
        updatedAt
        quests {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteRide = /* GraphQL */ `
  subscription OnDeleteRide {
    onDeleteRide {
      id
      createdAt
      title
      duration
      kilometers
      wattHours
      coinGain
      starGain
      completed
      owner
      worldId
      updatedAt
      player {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      activityPeriod {
        id
        createdAt
        owner
        startDate
        effortCount
        starCount
        wattHrs
        coinCount
        rideDuration
        effortTotal
        starTotal
        wattHrsTotal
        coinTotal
        rideDurTotal
        updatedAt
        rides {
          nextToken
        }
        questEfforts {
          nextToken
        }
      }
      questEfforts {
        items {
          id
          createdAt
          score
          metric
          starRating
          starGain
          completed
          isRankChecked
          owner
          questId
          rideId
          updatedAt
        }
        nextToken
      }
      questRanks {
        items {
          createdAt
          score
          starRating
          owner
          questId
          rideId
          effortId
          updatedAt
        }
        nextToken
      }
      world {
        id
        title
        createdAt
        updatedAt
        quests {
          nextToken
        }
      }
    }
  }
`;
export const onCreateQuestEffort = /* GraphQL */ `
  subscription OnCreateQuestEffort {
    onCreateQuestEffort {
      id
      createdAt
      score
      metric
      starRating
      starGain
      completed
      isRankChecked
      owner
      questId
      rideId
      updatedAt
      player {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      activityPeriod {
        id
        createdAt
        owner
        startDate
        effortCount
        starCount
        wattHrs
        coinCount
        rideDuration
        effortTotal
        starTotal
        wattHrsTotal
        coinTotal
        rideDurTotal
        updatedAt
        rides {
          nextToken
        }
        questEfforts {
          nextToken
        }
      }
      ride {
        id
        createdAt
        title
        duration
        kilometers
        wattHours
        coinGain
        starGain
        completed
        owner
        worldId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        questEfforts {
          nextToken
        }
        questRanks {
          nextToken
        }
        world {
          id
          title
          createdAt
          updatedAt
        }
      }
      quest {
        id
        title
        worldId
        type
        kilometers
        checkpointCount
        starsToUnlock
        createdAt
        updatedAt
      }
    }
  }
`;
export const onUpdateQuestEffort = /* GraphQL */ `
  subscription OnUpdateQuestEffort {
    onUpdateQuestEffort {
      id
      createdAt
      score
      metric
      starRating
      starGain
      completed
      isRankChecked
      owner
      questId
      rideId
      updatedAt
      player {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      activityPeriod {
        id
        createdAt
        owner
        startDate
        effortCount
        starCount
        wattHrs
        coinCount
        rideDuration
        effortTotal
        starTotal
        wattHrsTotal
        coinTotal
        rideDurTotal
        updatedAt
        rides {
          nextToken
        }
        questEfforts {
          nextToken
        }
      }
      ride {
        id
        createdAt
        title
        duration
        kilometers
        wattHours
        coinGain
        starGain
        completed
        owner
        worldId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        questEfforts {
          nextToken
        }
        questRanks {
          nextToken
        }
        world {
          id
          title
          createdAt
          updatedAt
        }
      }
      quest {
        id
        title
        worldId
        type
        kilometers
        checkpointCount
        starsToUnlock
        createdAt
        updatedAt
      }
    }
  }
`;
export const onDeleteQuestEffort = /* GraphQL */ `
  subscription OnDeleteQuestEffort {
    onDeleteQuestEffort {
      id
      createdAt
      score
      metric
      starRating
      starGain
      completed
      isRankChecked
      owner
      questId
      rideId
      updatedAt
      player {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      activityPeriod {
        id
        createdAt
        owner
        startDate
        effortCount
        starCount
        wattHrs
        coinCount
        rideDuration
        effortTotal
        starTotal
        wattHrsTotal
        coinTotal
        rideDurTotal
        updatedAt
        rides {
          nextToken
        }
        questEfforts {
          nextToken
        }
      }
      ride {
        id
        createdAt
        title
        duration
        kilometers
        wattHours
        coinGain
        starGain
        completed
        owner
        worldId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        questEfforts {
          nextToken
        }
        questRanks {
          nextToken
        }
        world {
          id
          title
          createdAt
          updatedAt
        }
      }
      quest {
        id
        title
        worldId
        type
        kilometers
        checkpointCount
        starsToUnlock
        createdAt
        updatedAt
      }
    }
  }
`;
export const onCreateQuestRank = /* GraphQL */ `
  subscription OnCreateQuestRank {
    onCreateQuestRank {
      createdAt
      score
      starRating
      owner
      questId
      rideId
      effortId
      updatedAt
      player {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      ride {
        id
        createdAt
        title
        duration
        kilometers
        wattHours
        coinGain
        starGain
        completed
        owner
        worldId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        questEfforts {
          nextToken
        }
        questRanks {
          nextToken
        }
        world {
          id
          title
          createdAt
          updatedAt
        }
      }
      effort {
        id
        createdAt
        score
        metric
        starRating
        starGain
        completed
        isRankChecked
        owner
        questId
        rideId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        ride {
          id
          createdAt
          title
          duration
          kilometers
          wattHours
          coinGain
          starGain
          completed
          owner
          worldId
          updatedAt
        }
        quest {
          id
          title
          worldId
          type
          kilometers
          checkpointCount
          starsToUnlock
          createdAt
          updatedAt
        }
      }
      quest {
        id
        title
        worldId
        type
        kilometers
        checkpointCount
        starsToUnlock
        createdAt
        updatedAt
      }
    }
  }
`;
export const onUpdateQuestRank = /* GraphQL */ `
  subscription OnUpdateQuestRank {
    onUpdateQuestRank {
      createdAt
      score
      starRating
      owner
      questId
      rideId
      effortId
      updatedAt
      player {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      ride {
        id
        createdAt
        title
        duration
        kilometers
        wattHours
        coinGain
        starGain
        completed
        owner
        worldId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        questEfforts {
          nextToken
        }
        questRanks {
          nextToken
        }
        world {
          id
          title
          createdAt
          updatedAt
        }
      }
      effort {
        id
        createdAt
        score
        metric
        starRating
        starGain
        completed
        isRankChecked
        owner
        questId
        rideId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        ride {
          id
          createdAt
          title
          duration
          kilometers
          wattHours
          coinGain
          starGain
          completed
          owner
          worldId
          updatedAt
        }
        quest {
          id
          title
          worldId
          type
          kilometers
          checkpointCount
          starsToUnlock
          createdAt
          updatedAt
        }
      }
      quest {
        id
        title
        worldId
        type
        kilometers
        checkpointCount
        starsToUnlock
        createdAt
        updatedAt
      }
    }
  }
`;
export const onDeleteQuestRank = /* GraphQL */ `
  subscription OnDeleteQuestRank {
    onDeleteQuestRank {
      createdAt
      score
      starRating
      owner
      questId
      rideId
      effortId
      updatedAt
      player {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      ride {
        id
        createdAt
        title
        duration
        kilometers
        wattHours
        coinGain
        starGain
        completed
        owner
        worldId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        questEfforts {
          nextToken
        }
        questRanks {
          nextToken
        }
        world {
          id
          title
          createdAt
          updatedAt
        }
      }
      effort {
        id
        createdAt
        score
        metric
        starRating
        starGain
        completed
        isRankChecked
        owner
        questId
        rideId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        ride {
          id
          createdAt
          title
          duration
          kilometers
          wattHours
          coinGain
          starGain
          completed
          owner
          worldId
          updatedAt
        }
        quest {
          id
          title
          worldId
          type
          kilometers
          checkpointCount
          starsToUnlock
          createdAt
          updatedAt
        }
      }
      quest {
        id
        title
        worldId
        type
        kilometers
        checkpointCount
        starsToUnlock
        createdAt
        updatedAt
      }
    }
  }
`;
export const onCreateWorld = /* GraphQL */ `
  subscription OnCreateWorld {
    onCreateWorld {
      id
      title
      createdAt
      updatedAt
      quests {
        items {
          id
          title
          worldId
          type
          kilometers
          checkpointCount
          starsToUnlock
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onUpdateWorld = /* GraphQL */ `
  subscription OnUpdateWorld {
    onUpdateWorld {
      id
      title
      createdAt
      updatedAt
      quests {
        items {
          id
          title
          worldId
          type
          kilometers
          checkpointCount
          starsToUnlock
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onDeleteWorld = /* GraphQL */ `
  subscription OnDeleteWorld {
    onDeleteWorld {
      id
      title
      createdAt
      updatedAt
      quests {
        items {
          id
          title
          worldId
          type
          kilometers
          checkpointCount
          starsToUnlock
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onCreateQuest = /* GraphQL */ `
  subscription OnCreateQuest {
    onCreateQuest {
      id
      title
      worldId
      type
      kilometers
      checkpointCount
      starsToUnlock
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateQuest = /* GraphQL */ `
  subscription OnUpdateQuest {
    onUpdateQuest {
      id
      title
      worldId
      type
      kilometers
      checkpointCount
      starsToUnlock
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteQuest = /* GraphQL */ `
  subscription OnDeleteQuest {
    onDeleteQuest {
      id
      title
      worldId
      type
      kilometers
      checkpointCount
      starsToUnlock
      createdAt
      updatedAt
    }
  }
`;
